import { Standort } from '@/domain/mitarbeiter/features/rotationsplan/entities/Standort';
import { Select } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/components/SelectV2';
import { useStandortgruppe } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useStandortgruppen/useStandortgruppen';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';
import { Body } from '@e2n/ui/v2';

export function StandortSelect({
  handleChange,
  value,
  disabled = false,
  land,
}: {
  handleChange: (standort: Standort) => void;
  value: Standort;
  land: string;
  disabled?: boolean | undefined;
}) {
  const { t } = useTranslation();
  const { currentStandort } = useStandortContext();
  const { standortGruppe } = useStandortgruppe(
    currentStandort.idStandortgruppe,
  );
  const standorte =
    standortGruppe?.standorte.filter((s) => s.land === land) ?? [];

  return (
    <Select<Standort>
      disabled={disabled}
      onChange={handleChange}
      drawerLabel={t(
        'domain.mitarbeiter.rotationsplan.rotationsplaene.createStation.fields.standort.label',
      )}
      selectedOption={value}
      options={standorte}
      renderListItem={(standort, selectedStandort) => (
        <div className="flex items-center justify-between w-full">
          <Body className="min-w-0 truncate">
            {standort.storenummer && standort.storenummer.length > 0
              ? standort.storenummer + ' - ' + standort.name
              : standort.name}
          </Body>
          {standort.id === selectedStandort?.id && (
            <FontAwesomeIcon
              className="size-4 text-brand-red-200"
              icon={faCheck}
            />
          )}
        </div>
      )}
    />
  );
}
